<template>
  <section>
    <nav-bar :noSidbar="true"></nav-bar>
    <div class="create-view">
      <div class="create-view__wrap">
        <StepbarCompany></StepbarCompany>
        <router-view></router-view>
      </div>
    </div>
  </section>
</template>

<script>
import NavBar from "@/components/common/NavBarUser.vue";
import StepbarCompany from "@/components/common/stepbars/StepbarCompany.vue";
export default {
  components: { NavBar, StepbarCompany },
};
</script>

<style lang="scss" scoped>
.create-view {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;

  .create-view__wrap {
    width: 100%;
    padding: 64px 15px;
    box-sizing: border-box;
  }
}
@media only screen and (min-width: 600px) {
  .create-view {
    scrollbar-gutter: stable both-edges;
    .create-view__wrap {
      width: 500px;
      padding: 50px 0;
      box-sizing: border-box;
    }
  }
}
</style>
